// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dxtntadwVsoDWamv {
  background-color: #ffffff;
  margin-top: 20px;
  border-radius: 10px;
  padding: 20px;
  height: calc(100vh - 150px);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.dxtntadwVsoDWamv .highlighted_row {
  background-color: #2ecc709a !important;
}

.S88tC8CS5k8fqzpX {
  background-color: #0078ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Table/Table.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper {\r\n  background-color: #ffffff;\r\n  margin-top: 20px;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  height: calc(100vh - 150px);\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.wrapper :global(.highlighted_row) {\r\n  background-color: #2ecc709a !important;\r\n}\r\n\r\n.paginationBtn {\r\n  background-color: #0078ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `dxtntadwVsoDWamv`;
export var paginationBtn = `S88tC8CS5k8fqzpX`;
export default ___CSS_LOADER_EXPORT___;
